import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

const tabs = [
  { to: '/', label: 'Daily', end: true },
  { to: '/levels', label: 'Levels' },
  { to: '/leaderboard', label: 'Ranks' },
  { to: '/stats', label: 'Stats' },
  { to: '/settings', label: 'Settings' },
];

export function Layout() {
  const { logout } = useAuth();
  return (
    <div className="app">
      <header className="app-bar">
        <span className="brand">Sudoku</span>
        <button type="button" className="link" onClick={logout}>
          Sign out
        </button>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <nav className="tab-bar" aria-label="Primary">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) => (isActive ? 'tab active' : 'tab')}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
